/*eslint  @typescript-eslint/no-use-before-define: 0*/

import { defineModule } from "direct-vuex";
import { moduleActionContext, moduleGetterContext } from "@/store";
import FinancesRequestsForPaymentModule from "@/store/modules/finances/requestsForPayment";
import FinancesCashReportsModule from "@/store/modules/finances/cashReports";
import FinancesCashDocumentsModule from "@/store/modules/finances/cashDocuments";
import BankTransfersModule from "@/store/modules/finances/bankTransfersModule";
import BankOperationsModule from "@/store/modules/finances/bankOperationsModule";
import CreditCardStatementsModule from "@/store/modules/finances/creditCardStatements";

const FinancesModule = defineModule({
  modules: {
    requestsForPayment: FinancesRequestsForPaymentModule,
    cashReports: FinancesCashReportsModule,
    cashDocuments: FinancesCashDocumentsModule,
    bankTransfers: BankTransfersModule,
    bankOperations: BankOperationsModule,
    creditCardStatements: CreditCardStatementsModule,
  },
  namespaced: true as const,
});

export default FinancesModule;

/* eslint-disable */
// noinspection JSUnusedLocalSymbols
const _moduleGetterContext = (args: [any, any, any, any]) =>
  moduleGetterContext(args, FinancesModule);
const _moduleActionContext = (context: any) =>
  moduleActionContext(context, FinancesModule);
